export const initState = {
  workspaces: [],
  selectedWorkspace: null,
  // The groupId this selection was resolved under. redux-persist rehydrates
  // this whole slice from localStorage on load, so a stale selectedWorkspace
  // can otherwise survive a real login with a *different* groupId (e.g.
  // after being reassigned in Player Management) -- tagging it lets the saga
  // tell a still-valid remembered choice apart from a stale persisted one.
  selectedWorkspaceGroupId: null,
  isLoading: false
};

export const types = {
  GET_ALL_WORKSPACES: "GET_ALL_WORKSPACES",
  GET_ALL_WORKSPACES_SUCCESS: "GET_ALL_WORKSPACES_SUCCESS",
  GET_ALL_WORKSPACES_FAILED: "GET_ALL_WORKSPACES_FAILED",
  SET_SELECTED_WORKSPACE: "SET_SELECTED_WORKSPACE",
  SET_SELECTED_WORKSPACE_SUCCESS: "SET_SELECTED_WORKSPACE_SUCCESS",
  SET_SELECTED_WORKSPACE_FAILED: "SET_SELECTED_WORKSPACE_FAILED",
  SET_WORKSPACES: "SET_WORKSPACES",
};
